module.exports = __webpack_public_path__ + "static/media/Welcome.41c59c2e.svg";